<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-date-picker
            v-model="payTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开卡时间范围"
            end-placeholder="开卡时间范围"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 100%"
            clearable
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-select
            placeholder="请选择订单核销类型"
            v-model="query.verifyState"
            style="width: 100%"
          >
            <el-option
              v-for="item in orderTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain size="mini" @click="exportFun" v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
      </div>
    </div>
    <div class="query-wapper query-wapper-second">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-date-picker
            v-model="completeTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="退售完成时间范围"
            end-placeholder="退售完成时间范围"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 100%"
            clearable
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain size="mini" @click="exportVerifyExcel" v-loading.fullscreen.lock="fullscreenLoading"
          >导出</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import _paymentService from "@/service/payment-inquiry-service";

export default {
  data() {
    return {
      payTime: [],
      completeTime: [],
      query: {
        verifyState: "",
        activationTimeStart: "",
        activationTimeEnd: "",
        moduleType: "order",
      },
      exportVerifyExcelOrder: {
        completeStartTime: "",
        completeEndTime: "",
        moduleType: "refund",
      },
      paymentTypeList: null,
      orderTypeList: null,
      fullscreenLoading: false,
      timer: null
    };
  },
  mounted() {
    this.getOrderType();
  },
  methods: {
    getOrderType() {
      _paymentService.paymentTypeList({ state: "PcVerifyStateEnum" }, (res) => {
        this.orderTypeList = res;
      });
    },

    exportFun() {
      
      if (this.payTime) {
        this.query.activationTimeStart = this.payTime[0];
        this.query.activationTimeEnd = this.payTime[1];
      } else {
        this.query.activationTimeStart = "";
        this.query.activationTimeEnd = "";
      }
      if (this.query.verifyState == "" && this.payTime.length<=0) {
        this.$notify({
          message: "必选其一",
          type: "warning",
        });
        return;
      }
      let _this = this
      this.fullscreenLoading = true
      _paymentService.exportVerifyExcelOrder(
        this.query,
        (response) => {
          if (response.state == 0) {
                clearInterval( _this.timer)
                  _this.timer = setInterval(() => {
                    _this.exportFun()
                  },1000)
              } else if (response.state == 1) {
                  clearInterval( _this.timer)
                  _this.fullscreenLoading = false            
                  window.location.href =  response.url                          
          }
        },
        response => {
          clearInterval(_this.timer)
          this.$notify({
            message: response,
            type: "warning",
          });
          _this.fullscreenLoading = false
        }
      );
    },
    exportVerifyExcel() {

      if (this.completeTime == null || this.completeTime.length<=0) {
        this.$notify({
          message: "请选择退售时间",
          type: "warning",
        });
        return;
      }
      this.exportVerifyExcelOrder.completeStartTime = this.completeTime[0];
      this.exportVerifyExcelOrder.completeEndTime = this.completeTime[1];
  

      let _this = this
      this.fullscreenLoading = true
      _paymentService.exportVerifyExcelOrder(
        this.exportVerifyExcelOrder,
        (response) => {
          if (response.state == 0) {
                clearInterval( _this.timer)
                  _this.timer = setInterval(() => {
                    _this.exportVerifyExcel()
                  },1000)
              } else if (response.state == 1) {
                  clearInterval( _this.timer)
                  _this.fullscreenLoading = false            
                  window.location.href =  response.url                          
          }
        },
        (response) => {
          clearInterval(_this.timer)
          this.$notify({
            message: response,
            type: "warning",
          });
          _this.fullscreenLoading = false
        }
      );
    },
  },
};
</script>

<style scoped>
.wapper /deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;
}

.wapper /deep/.el-date-editor .el-range-input {
  width: 72%;
}

.tips {
  color: red;
}
.times {
  margin-bottom: 20px;
}
.ordinaryEditoreTips {
  margin-left: 4px;
}
.wapper {
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.header {
  margin-bottom: 15px;
}

.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
  width: 100%;
}

.query-wapper::after {
  position: absolute;
  content: "订单导出";
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}
.query-wapper-second::after {
  content: "退售单导出";
}
.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
  flex: 1;
  width: 100%;
  overflow-y: scroll;
}

.button-wapper {
  margin-top: 10px;
}

.el-row {
  margin-bottom: 15px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
